import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Fragment } from "react";
import { LEZ, Scenario } from "src/types";
import { PaneListEmptyPlaceholder } from "src/components/PaneListEmptyPlaceholder";
import { LEZListItem } from "src/components/LEZListItem";

interface Props {
  scenario: Scenario;
  lezs: LEZ[];
}

export function LEZList(props: Props) {
  const { scenario, lezs } = props;
  const { t } = useTranslation();
  return render();

  function render() {
    if (!lezs || !scenario) return null;

    if (lezs.length === 0) {
      return (
        <Grid item xs={12}>
          <PaneListEmptyPlaceholder>{t("label.noLowEmissionZoneFound")}</PaneListEmptyPlaceholder>
        </Grid>
      );
    }

    return (
      <Fragment>
        {lezs.map((lez) => (
          <Grid item xs={12} key={lez.id}>
            <LEZListItem lez={lez} scenario={scenario} lezs={lezs} />
          </Grid>
        ))}
      </Fragment>
    );
  }
}
